// extracted by mini-css-extract-plugin
export default {"text":"cardarticleCompoStyle_text__gUJwa"};